import { combineReducers } from 'redux'
import guest from './guest'
import book from './book'
import locale from './locale'
import operationLogs from './operationLogs'

export default combineReducers({ guest, book, locale, operationLogs })